import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SalesDiscountReferenceService extends BaseReferenceService {
  constructor() {
    super('SalesDiscountReference');
  }
}
